export const mojoPath = (mojoId: Number) => `/mojo/${mojoId}`;
